module.exports = __webpack_public_path__ + "img/Body_MetalRoughness.2d405bb.jpg";